export default "__VITE_ASSET__BQuJHQul__"